// src/PrivacyPolicy.js

import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p>
        At Geografifa, we take your privacy seriously. This privacy policy outlines how we collect, use, and protect your personal information when you use our website.
      </p>
      <h2>Information We Collect</h2>
      <p>
        As far as I know, all data submitted and recalled in anonymous. No user emails, location or any other information is stored anywhere. Google AdSense is used on this site, so their situation is most likely different.
      </p>
      <h2>Google AdSense and Cookies</h2>
      <p>
        Our website uses <strong>Google AdSense</strong> to display ads. AdSense uses cookies to deliver targeted ads based on your interests and browsing history. Third-party vendors, including Google, use cookies to serve ads based on your previous visits to this website or other websites.
      </p>
      <p>
        You can opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google Ads Settings</a>.
      </p>
      <h2>Third-Party Services</h2>
      <p>
        We may use third-party services that collect, monitor, and analyze your browsing activity. These services adhere to their privacy policies.
      </p>
      <h2>Your Consent</h2>
      <p>
        By using our site, you consent to our privacy policy. If we decide to change our privacy policy, we will post those changes on this page.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
